import React from 'react';
import { Info, Zap, Users, ShieldCheck, HeartHandshake } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    title: 'Información clara',
    description: 'Encuentra rápidamente reuniones, documentos, calendarios, comités y recursos importantes.',
    icon: Info
  }, {
    title: 'Acción rápida',
    description: 'Reporta problemas, contacta al comité o suscríbete a alertas sin perder tiempo.',
    icon: Zap
  }, {
    title: 'Participación accesible',
    description: 'Puedes asistir a reuniones, enviar comentarios, revisar documentos o involucrarte como voluntario.',
    icon: HeartHandshake
  }, {
    title: 'Comunidad más conectada',
    description: 'Vecinos, familias, jóvenes, adultos mayores, negocios locales y líderes comunitarios pueden mantenerse al día desde un mismo lugar.',
    icon: Users
  }, {
    title: 'Más confianza',
    description: 'Una página clara, organizada y actualizada ayuda a que la comunidad sepa dónde buscar información oficial.',
    icon: ShieldCheck
  }];
  return <section className="py-24 px-6 lg:px-8 bg-sylmar-light" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-31">
            Beneficios Principales
          </h2>
          <div className="w-24 h-1 bg-sylmar mx-auto rounded-full" data-id="element-32"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-33">
          {benefits.map((benefit, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow ${index === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-2 lg:max-w-xl lg:mx-auto' : ''}`} data-id="element-34">
              <div className="w-14 h-14 bg-softblue-dark rounded-xl flex items-center justify-center mb-6" data-id="element-35">
                <benefit.icon className="w-7 h-7 text-sky" data-id="element-36" />
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-37">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-38">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}